import React from "react";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { Field } from "formik";
import { FormikFileUpload } from "../../../FormikFileUpload";

interface Props {
  id: string;
  onStatusChange?: (filesUploadStatus: FileSelectUploadStatus) => void;
}

export const DISCONNECTION_ATTACHMENT_TYPE = "Meter Info";

export const DisconnectionDetailsFileUpload: React.FC<Props> = ({
  id,
  onStatusChange,
}) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.7}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      mt={0}
    >
      <Span lineHeight={2} mb={3}>
        Please upload photos of the electricity meter(s) that are to be
        disconnected (max. 5 files, pdf, dwg, jpg, gif, png, or tiff format)
      </Span>

      <Field
        id="disconnectionDetails.meterPhotos"
        name="disconnectionDetails.meterPhotos"
        acceptFileTypes={[
          "application/dwg",
          "application/pdf",
          "application/x-dwg",
          "image/gif",
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/tif",
          "image/tiff",
          "image/vnd.dwg",
          "image/x-dwg",
        ]}
        onStatusChange={onStatusChange}
        attachmentType={DISCONNECTION_ATTACHMENT_TYPE}
        component={FormikFileUpload}
      />
    </Flex>
  );
};
